import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {FormComponent} from 'lf-at-theme';
import {INITIAL_VALUES, IntermediaryInitialValues} from '../tokens';

@Component({
  selector: 'app-intermediary-form',
  templateUrl: './intermediary-form.component.html',
  styleUrls: ['./intermediary-form.component.scss']
})
export class IntermediaryFormComponent implements OnInit {

  @ViewChild('form') _lfForm: FormComponent;

  constructor(@Inject(INITIAL_VALUES) public initialValues: IntermediaryInitialValues) {
  }

  ngOnInit(): void {
  }

  get hasCadastroData() {
    return this.initialValues.hasCadastroData;
  }

  showExtraAddressFields(address): boolean {
    return address.suite
      || address.postOfficeBox
      || address.district
      || address.countrySubEntity
      || address.otherLocalId;
  }
}
